import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/Auth";
import snackBar from "./modules/snackBar";
import groups from "./modules/groups";
import trendingTrades from "./modules/trending/profitableTrades";
import performingTraders from "./modules/trending/performingTraders";
import upcomingTrades from "./modules/trending/upcomingTrades";
import blockUser from "./modules/BlockUser";
import tradeData from "./modules/TradeData";
import securityWidget from "./modules/SecurityWidget";
import group from "./modules/Group";
import payment from "./modules/Payment";
import user from "./modules/User";
import watchlistModal from "./modules/WatchlistModal";
import modalDisplay from "./modules/VideoCourseModule/modalDisplay";
import addTrade from "./modules/AddTrade";
import adminGroup from "./adminPanel/GroupDetail";
import rejectModal from "./adminPanel/RejectModal";
import adminTeam from "./adminPanel/AdminTeam";
import approveModal from "./adminPanel/ApproveModal";
import videoCourse from "./modules/VideoCourse";
import deleteModal from "./modules/DeleteModal";
import securityPage from "./modules/SecurityPage";
import deleteAccount from "./modules/DeleteAccount";
import profile from "./modules/Profile";
import tradeCardDialog from "./modules/TradeCardDialog/index";
import paperTrades from "./modules/PaperTrades";
import fOTradeData from "./modules/F&OTradeData/index";
import login from "./modules/login/index";
import webinar from "./modules/webinar";
import subscription from "./modules/Subscription";
import trading from "./modules/trading";
import ResearchReport from "./modules/trending/researchReports";
import poll from "./modules/Home/poll";
import gamification from "./gamification/index";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    Auth,
    snackBar,
    groups,
    trendingTrades,
    performingTraders,
    upcomingTrades,
    blockUser,
    tradeData,
    securityWidget,
    group,
    payment,
    watchlistModal,
    modalDisplay,
    addTrade,
    adminGroup,
    rejectModal,
    approveModal,
    adminTeam,
    videoCourse,
    deleteModal,
    securityPage,
    deleteAccount,
    profile,
    tradeCardDialog,
    paperTrades,
    fOTradeData,
    login,
    webinar,
    subscription,
    trading,
    ResearchReport,
    poll,
    gamification,
  },
});

// .left__col{
//   background-color: red !important;
//   background: url('../../assets/images/Landingpageposter.jpg');
//   background-size: 100% 100%;
//   background-repeat: no-repeat;

//   min-height: 100vh !important;

// }
